import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Guid as P } from "../../shared-lib/index.js";
var u = /*#__PURE__*/function () {
  function u() {
    _classCallCheck(this, u);
    this.yi = {};
  }
  _createClass(u, [{
    key: "wt",
    value: function wt(t) {
      if ("function" != typeof t) return null;
      var i = P.oe();
      return this.yi[i] = t, i;
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      delete this.yi[t];
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this.yi = {};
    }
  }, {
    key: "sc",
    value: function sc() {
      return Object.keys(this.yi).length;
    }
  }, {
    key: "L",
    value: function L(t) {
      var i = [];
      for (var s in this.yi) {
        var r = this.yi[s];
        i.push(r(t));
      }
      return i;
    }
  }]);
  return u;
}();
export { u as default };